import type { IntegrationValidationError } from 'api';

export const extractIntegrationValidationError = (
  error: IntegrationValidationError | null | undefined,
  fallback: string
): string => {
  const envelope = error?.error;
  if (!envelope) {
    return fallback;
  }

  const messages = Object.entries(envelope.details ?? {}).flatMap(
    ([field, value]) =>
      (Array.isArray(value) ? value : [value]).map(
        (message) => `${field} ${message}`
      )
  );
  if (messages.length > 0) {
    return messages.join('. ');
  }

  return typeof envelope.title === 'string' && envelope.title.length > 0
    ? envelope.title
    : fallback;
};
